<div class="form-toggle" [class.disabled]="disabled" (click)="onContainerClick()">
    <span
        #switchElement
        class="form-toggle__switch"
        [class.checked]="_checked"
        role="switch"
        [attr.aria-checked]="_checked"
        [attr.aria-label]="ariaLabel || null"
        [attr.aria-labelledby]="ariaLabel ? null : labelId"
        [attr.aria-describedby]="ariaDescribedby || null"
        [attr.aria-disabled]="disabled"
        [attr.tabindex]="disabled ? -1 : 0"
        (keydown.space)="$event.preventDefault(); toggle()"
        (keydown.enter)="$event.preventDefault(); toggle()"
    >
        <span class="form-toggle__handle"></span>
    </span>
    <span class="form-toggle__label" [id]="labelId"><ng-content></ng-content></span>
</div>
